import Controller from "../componentes/Controller.vue";
import ListaIntegraciones from "./../componentes/ListaIntegraciones.vue";
import ListaLog from "../../usuarios/componentes/ListaLog.vue";

const routes = [...route("/controller", Controller, {})];

function route(path, component = Default, meta = {}) {
    return [
        {
            path,
            component,
            meta,
        },
    ];
}

export default [
    ...routes,
    {
        path: "/integraciones",
        component: ListaIntegraciones,
        meta: { Auth: true },
    },
    {
        path: "/logs-acceso",
        component: ListaLog,
        meta: { Auth: true },
    },
];
